/* eslint-disable */
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { CircularLoading } from "../../Styles/ComponentStyles";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { Button } from "@material-ui/core";
import Assignment from "@material-ui/icons/Assignment";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import IDCARD from "../../Styles/Icons/idcard.png";
import USER from "../../Styles/Icons/user.png";
import BELL from "../../Styles/Icons/bell.png";
import MEGAPHONE from "../../Styles/Icons/megaphone.png";
import HEURED from "../../Styles/Icons/clockD.png";
import HEUREF from "../../Styles/Icons/clockF.png";
import ASTREINTE from "../../Styles/Icons/oncall.png";

import { styles } from "../../Styles/ComponentStyles";
import { CustomTableCell } from "../../Styles/ComponentStyles";

import Config from "../../config.js";
import PropTypes from "prop-types";

// The order and what we decide to show to the user
const header_names = [
  "AccountID",
  "UserID",
  "AlarmName",
  "Channel",
  "TimeBegin",
  "TimeEnd",
  "OnCall"
];

class ReportDashboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      account_list: props.account_list,
      app: props.app,
      flow: props.flow,
      report_count: 3,
      reports: {
        "users": ["riri,fifi,lulu"],
        "name": ["mon rapport"],
        "creationDate": ["2023-01-28"],
        "nextDate": ["2023-01-28"],
        "freq": ["weekly"],
        "stepper": ["dev,stg,prd"]
      }
    };
  }

  renderEnvReportStepper(){
    if (this.state.app !== "undefined") {
      return (
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
          {this.state.app + " " + ":" + " " + "flux de rapport"}
        </TableCell>
      );
    } else {
      return(
        <TableCell>
          {"no" + "-" + "env"}
        </TableCell>
      );  
    }
  }

  renderCellTableHeader(){
    return(
      <TableRow
        style={{
          border: "none",
          height: "10px"
        }}
      >
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
        {""}
        </TableCell>
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
        {"nom du rapport"}
        </TableCell>
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
        {"frequence"}
        </TableCell>
        {this.renderEnvReportStepper()}
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
        {"destinataire"}
        </TableCell>
        <TableCell
          style={{
            border: "none",
            "border-radius": "0 0 0 0",
            background: "#dff2ed",
            color: "#139aa1",
            "font-weight": "bold",
            "font-size": "14px",
            maxWidth: "60px",
            textTransform: "lowercase",
            textAlign: "left",
            height: "40px"
          }}
        >
        {"prochaine date"}
        </TableCell>
      </TableRow>
    );
  }

  renderCellUsersReport(){
    return(
      this.state.reports.users.map( isUser => {
        return(
            <TableCell>{isUser}</TableCell>
        )})
    );
  }

  renderCellNameReport(){
    return(
      this.state.reports.name.map( isName => {
        return(
          <>
            <Assignment
              style={{
                marginTop: "10px"
              }}
            />
            <TableCell>{isName}</TableCell>
          </>
        )})
    );
  }

  renderCellStepperReport(){
    return(
      this.state.reports.stepper.map( isStepper => {
        return(
            <TableCell>{isStepper}</TableCell>
        )})
    );
  }

  renderCellCreationReport(){
    return(
      this.state.reports.creationDate.map( isCreated => {
        return(
            <TableCell>{isCreated}</TableCell>
        )})
    );
  }

  renderCellNextReport(){
    return(
      this.state.reports.nextDate.map( isNext => {
        return(
            <TableCell>{isNext}</TableCell>
        )})
    );
  }

  renderCellFreqReport(){
    return(
      this.state.reports.freq.map( isFreq => {
        return(
            <TableCell>{isFreq}</TableCell>
        )})
    );
  }

  renderCellStepReport(env){
    return(
            <TableCell>{env + "-" + "report name"}</TableCell>
    );
  }

  renderCellFlowReport(){
    return(
            <TableCell>{this.state.flow}</TableCell>
    );
  }

  render() {
    const { classes } = this.props;
    if (this.state.report_count >= 0) {
      return (
        <div style={{ overflowX: "hidden" }}>
          <Paper
            className={classes.paperChannelList}
            style={{
              background: "#f7faf9",
              "margin-left": "auto",
              "margin-right": "auto",
              "margin-bottom": "40px",
              overflowX: "hidden",
              maxWidth: "1300px",
              "box-shadow": "none"
            }}
          >
            <Table>
              <TableHead>
                {this.renderCellTableHeader()}            
              </TableHead>
              <TableBody>
                <TableRow>
                {this.renderCellNameReport()}
                {this.renderCellFreqReport()}
                {this.renderCellFlowReport()}
                {this.renderCellUsersReport()}
                {this.renderCellNextReport()}
                </TableRow>
                <TableRow>
                {this.renderCellNameReport()}
                {this.renderCellFreqReport()}
                {this.renderCellFlowReport()}
                {this.renderCellUsersReport()}
                {this.renderCellNextReport()}
                </TableRow>
                <TableRow>
                {this.renderCellNameReport()}
                {this.renderCellFreqReport()}
                {this.renderCellFlowReport()}
                {this.renderCellUsersReport()}
                {this.renderCellNextReport()}
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
          <Button
              color="primary"
              size="medium"
              variant="contained"
              style={{
                backgroundColor: "secondary",
                "box-shadow": "none",
                "border-radius": "20px",
                border: "none",
                "font-weight": "bold",
                color: "#ffffff",
                margin: "10px"
              }}
            >
              PLANIFIER UN RAPPORT
            </Button>
        </div>
      );
    } else {
      return <CircularLoading></CircularLoading>;
    }
  }
}

ReportDashboardTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReportDashboardTable);